<template>
  <div class="dialog-panel">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "dialogPanel"
}
</script>

<style lang="scss" scoped>
  .dialog-panel{
    background: #FFFFFF ;
    // margin : 20px 0 20px 0;
    padding: 0px 20px 0px 20px ;
    border-radius: 5px;
    margin-bottom: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/components/business/dialogPanel.vue